import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Switch, Stack } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import EditIcon from '@mui/icons-material/Edit'

import { MarketerEdit } from '../dialog'
import { useMarketersCalls } from '../../hooks'
import { useModalContext } from '../../../../ui'
import { toggleMarketerActive } from '../../slices'
import { tableActionsStyles } from './table-actions.styles'

const PREFIX = 'TableActions'

const classes = {
  root: `${PREFIX}-root`,
  switchBase: `${PREFIX}-switchBase`,
  track: `${PREFIX}-track`,
  checked: `${PREFIX}-checked`,
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginRight: 10,
  },

  [`& .${classes.switchBase}`]: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },

  [`& .${classes.track}`]: {
    backgroundColor: theme.palette.grey[500],
  },

  [`& .${classes.checked}`]: {},
}))

export const TableActions = ({ cell }) => {
  const navigate = useNavigate()
  const {
    actions: { open },
  } = useModalContext()
  const { getMarketer } = useMarketersCalls()
  const [marketer, setMarketer] = useState({})

  const styles = tableActionsStyles()

  if (!cell) {
    return null
  }
  const rowData = cell.row.original
  const marketerId = rowData['id']

  const handleGoToDetail = () => navigate(`${marketerId}`)

  const handleEditMarketer = () =>
    open({
      Component: MarketerEdit,
      data: { marketerId, marketer, setMarketer, getMarketer, rowData },
      type: 'fullScreen',
    })

  const tariffButtons = {
    edit: {
      onClick: handleEditMarketer,
      icon: <EditIcon />,
    },
    detail: {
      onClick: handleGoToDetail,
      icon: <SearchIcon />,
    },
  }

  const availableActions = ['detail', 'edit']

  return (
    <Stack direction="row" spacing={3} p={0} justifyContent="center" alignItems="center">
      {availableActions.map((action) => {
        return (
          <IconButton
            key={action}
            size="small"
            onClick={tariffButtons[action].onClick}
            sx={styles.actionButton}
          >
            {tariffButtons[action].icon}
          </IconButton>
        )
      })}
    </Stack>
  )
}

export const TableActive = ({ cell }) => {
  const dispatch = useDispatch()
  const global = useSelector((state) => state.global)
  const marketers = useSelector((state) => state.marketers.data)

  if (!cell) {
    return null
  }
  const rowData = cell.row.original

  const switchDisabled = '' + rowData.id === global.user_id
  const marketerActiveState = rowData['activo']

  const handleToggleState = () => dispatch(toggleMarketerActive(rowData, marketers))

  return (
    <StyledSwitch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        track: classes.track,
        checked: classes.checked,
      }}
      checked={marketerActiveState}
      onClick={handleToggleState}
      disabled={switchDisabled}
    />
  )
}
